import { Component, DestroyRef, inject, signal } from '@angular/core';
import { rxResource, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { form, FormField } from '@angular/forms/signals';
import { NgClass } from '@angular/common';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, tap } from 'rxjs';
import { HasRolesDirective } from 'keycloak-angular';

import { AssetService } from '../../../services/asset';
import { SpinnerLoaderDirective } from '../../../utilities/directives/spinner-loader.directive';
import { Pagination } from '../../../utilities/classes/pagination';
import { PaginationComponent } from '../../../utilities/components/pagination/pagination.component';
import { NotificationService } from '../../../utilities/services/notification.service';
import { VendorSelect } from '../../../utilities/components/vendor-select/vendor-select';
import { ModelModal } from './model-modal/model-modal';
import { DeviceModelItem } from '../../../models/asset';
import { Permission } from '../../../models/user';

@Component({
  selector: 'fs-device-model',
  imports: [FormField, SpinnerLoaderDirective, PaginationComponent, NgClass, VendorSelect, HasRolesDirective],
  templateUrl: './device-model.html',
  styleUrl: './device-model.scss'
})
export class DeviceModel {
  private readonly assetService = inject(AssetService);
  private readonly notificationService = inject(NotificationService);
  private readonly modalService = inject(NgbModal);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly permission = Permission;

  private readonly filterModel = signal({
    assetVendorId: '',
    name: ''
  });

  protected readonly paginationData: Pagination = new Pagination();
  protected readonly deviceModelFilter = form(this.filterModel);

  deviceModelResource = rxResource({
    params: () => ({ ...this.deviceModelFilter().value(), ...this.paginationData.paginationState() }),
    stream: ({ params }) => this.assetService.searchDeviceModels(params).pipe(
      tap((response) => this.paginationData.updateTotals(response.totalElements))
    )
  });

  async modelModal() {
    const modalRef = this.modalService.open(ModelModal, { size: 'lg' });
    await modalRef.result.then((result) => {
        if (result == 'refresh') this.deviceModelResource.reload();
    })
  }

  protected deleteModal(model: DeviceModelItem) {
    this.notificationService.openModal({
      title: 'Elimina Modello',
      type: 'danger',
      message: `Sei sicuro di voler eliminare il modello ${model.name}`,
      choice: 'multi'
    }).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((confirm) => {
      if (!confirm) return;
      this.deleteModel(model.id);
    });
  }

  protected deleteSubscription!: Subscription;
  private deleteModel(modelId: number) {
    this.deleteSubscription = this.assetService.deleteDeviceModel(modelId).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.deviceModelResource.reload();
      this.notificationService.showToast('Il modello è stato correttamente rimosso', { type: 'success' });
    });
  }
}
